import intl from 'react-intl-universal'
import Dialog from "material-ui/Dialog"
import { ModalText, ModalTitle, WrapperButtons } from './styled'
import PropTypes from 'prop-types'
import Button from 'components/button'
import ButtonIcon from 'components/button-icon'
import CloseIcon from 'components/icons/icn-close.icon'

export const ModalConfirmAction = ({ isOpen, handleClose, handleConfirm, title, textMessage, showIconCloseButton = false }) => (
  <Dialog
    open={isOpen}
    contentStyle={{ width: "600px" }}
    onRequestClose={handleClose}
  >
    <ModalTitle>{title}</ModalTitle>
    <ModalText>{textMessage}</ModalText>
    <WrapperButtons>
      <Button
        buttonType='default'
        value={intl.get('geral.modalConfirm.no')}
        onClick={handleClose}
        className="btn"
        style={{ margin: "0" }}
      />
      <Button
        buttonType="primary"
        value={intl.get('geral.modalConfirm.yes')}
        onClick={handleConfirm}
        className="btn margin-botao"
        style={{ margin: "0" }}
      />
      {showIconCloseButton && 
        <ButtonIcon
          buttonIcon={<CloseIcon />} 
          onClick={handleClose} 
          className="btn-icon-close-modal"
          buttonType='hidden'
          style={{ padding: "4px" }}
        />
      }
    </WrapperButtons>
  </Dialog>
)

ModalConfirmAction.propTypes = {
  handleConfirm: PropTypes.func,
  textMessage: PropTypes.string,
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func,
  title: PropTypes.string,
  showIconCloseButton: PropTypes.bool
}